import React from 'react';

import MobileHeader from '../MobileHeader';
import MobileTopMatch from '../MobileTopMatch';
import SportsList from '../SportsList';
import useMobileTopMatchList from './useMobileTopMatchList';

const MobileTopMatchList: React.FC = () => {
    const {
        periods,
        sportIds,
        missingSportEventIds,
        activeZones,
        activePeriod,
        activeSport,
        makeHandleActivePeriod,
        makeHandleChangeActiveSport,
    } = useMobileTopMatchList();

    if (!activeZones || !activePeriod) return null;

    return (
        <React.Fragment>
            <MobileHeader
                periods={periods}
                activeZoneIndex={activePeriod}
                makeHandleActiveZoneIndex={makeHandleActivePeriod}
            />

            <SportsList
                activeSport={activeSport}
                sportIds={sportIds}
                makeHandleChangeActiveSport={makeHandleChangeActiveSport}
            />

            <MobileTopMatch
                missingSportEventIds={missingSportEventIds}
                zones={activeZones}
                sport={activeSport}
            />
        </React.Fragment>
    );
};

export default React.memo(MobileTopMatchList);
